// Swedish

export default {

  component: {
    jobAdList: {
      title: 'Öppna jobb',
      jobs: 'jobb',
      noJobAds: 'Det finns för närvarande inga lediga tjänster.',
    },

    jobAdCard: {
      openUntil: date => `Öppen fram tills ${date}`,
    },

    jobAdGreetings: {
      thankYou: 'Tack.',
      readyInfo: 'Vi har tagit emot din ansökan och rekryteraren kommer att ta kontakt med dig inom kort.',
      luck: 'Lycka till!',
    },

    jobAdSeeYou: {
      title: 'Tack.',
      description: 'Din ansökan har sparats och vi har skickat en länk så att du kan fortsätta med ansökan senare.',
    },

    unpublished: {
      title: 'Opublicerad',
      info: 'Jobbannonsen har ännu inte publicerats.',
    },
  },

  page: {},

}
